const developmentCompanyIds = {
    "5c60469aff5cd815748df923": "HitechZone",
    "6693dc362a605ba17f95b265": "HitechZone",
    "6673303c5e9606512f6b47de": "RailNinja"
}

const productionCompanyIds = {
    "662152c33205a5d97e5e7a4e": "HitechZone",
    "6617df0557e3cb04df874af6": "RailNinja"
}

module.exports = {
    ...developmentCompanyIds,
    ...productionCompanyIds,
}